import { render, staticRenderFns } from "./ButtonInit.vue?vue&type=template&id=61457ad1&"
import script from "./ButtonInit.vue?vue&type=script&lang=js&"
export * from "./ButtonInit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports